export default function getInitialState() {
  return {
    raisedHands: {}
  };
}
